/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListMemoryEntriesQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListMemoryEntriesQueryParamOrder = ClosedEnum<
  typeof ListMemoryEntriesQueryParamOrder
>;

export type ListMemoryEntriesRequest = {
  memoryStoreId: string;
  limit?: number | undefined;
  order?: ListMemoryEntriesQueryParamOrder | undefined;
  after?: string | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListMemoryEntriesQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListMemoryEntriesQueryParamOrder
> = z.nativeEnum(ListMemoryEntriesQueryParamOrder);
/** @internal */
export const ListMemoryEntriesQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListMemoryEntriesQueryParamOrder
> = ListMemoryEntriesQueryParamOrder$inboundSchema;

/** @internal */
export const ListMemoryEntriesRequest$inboundSchema: z.ZodType<
  ListMemoryEntriesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  memory_store_id: z.string(),
  limit: z.number().int().default(20),
  order: ListMemoryEntriesQueryParamOrder$inboundSchema.default("desc"),
  after: z.string().optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "memory_store_id": "memoryStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListMemoryEntriesRequest$Outbound = {
  memory_store_id: string;
  limit: number;
  order: string;
  after?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListMemoryEntriesRequest$outboundSchema: z.ZodType<
  ListMemoryEntriesRequest$Outbound,
  z.ZodTypeDef,
  ListMemoryEntriesRequest
> = z.object({
  memoryStoreId: z.string(),
  limit: z.number().int().default(20),
  order: ListMemoryEntriesQueryParamOrder$outboundSchema.default("desc"),
  after: z.string().optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    memoryStoreId: "memory_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listMemoryEntriesRequestToJSON(
  listMemoryEntriesRequest: ListMemoryEntriesRequest,
): string {
  return JSON.stringify(
    ListMemoryEntriesRequest$outboundSchema.parse(listMemoryEntriesRequest),
  );
}
export function listMemoryEntriesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListMemoryEntriesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMemoryEntriesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMemoryEntriesRequest' from JSON`,
  );
}
